import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { Rating } from 'primereact/rating'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const Testimonials = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [testimonialsData, setTestimonialsData] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getTestimonials()
    }, [])

    const getTestimonials = () => {
        ApiHelper.get(API_ENDPOINTS.TESTIMONIALS).then((res) => {
            if (res.status === 200) {
                setTestimonialsData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            rowData?.name ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/badges/edit/${rowData.bannerId}`)} >
                    {rowData?.bannerTitle}
                </div>
            ) : null
        );
    };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.authorPhotoUrl ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/testimonials/edit/${rowData.testimonialId}`)} >
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/${rowData?.authorPhotoUrl}`}
                        alt=""
                        style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = "/img/placeholder-image.jpg"
                        }}
                    />
                    {rowData?.authorName}
                </div>
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'} `}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/testimonials/edit/${rowData.testimonialId}`)} className="btn btn-primary btn-sm me-2 mb-1"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.testimonialId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const ratingBodyTemplate = (rowData) => {
        return (
            <>
                <Rating value={rowData?.rating} disabled cancel={false} />
            </>
        );
    };


    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteTestimonial(id),
        });
    };

    const deleteTestimonial = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.TESTIMONIALS}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getTestimonials()
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page">Testimonials</p> </span></h4>
                            <Link class="btn btn-primary" to={'/testimonials/add'} >Add New Testimonials</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={testimonialsData} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Author Photo' body={imageBodyTemplate} field='authorPhotoUrl' />
                                            <Column sortable header='Testimonials' field='testimonial' />
                                            <Column sortable header='Company' field='company' />
                                            <Column sortable header='Rating' body={ratingBodyTemplate} field='rating' />
                                            <Column sortable header='Status' body={statusBodyTemplate} />
                                            <Column sortable header='Action' body={actionBodyTemplate} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Testimonials
